// Dynamic filtering for hide_variant_from_pdp metafield.
// Hides option values whose only compatible combinations with the current variant are
// all marked hidden via the custom.hide_variant_from_pdp variant metafield.
(function () {
  function init() {
    if (typeof window.__variantMeta === 'undefined') return;

    var allVariants = Object.keys(window.__variantMeta).map(function (id) {
      var m = window.__variantMeta[id];
      return {
        option1: m.option1,
        option2: m.option2,
        option3: m.option3,
        hideFromPdp: m.hide_from_pdp
      };
    });

    if (!allVariants.some(function (v) { return v.hideFromPdp; })) return;

    // Returns true when every variant that (a) has optionText at optionPosition and
    // (b) shares the same values at all OTHER positions as currentVariant has hideFromPdp set.
    function shouldHide(optionPosition, optionText, currentVariant) {
      var key = 'option' + optionPosition;
      var matching = allVariants.filter(function (v) { return v[key] === optionText; });
      if (matching.length === 0) return false;

      var compatible = matching.filter(function (v) {
        for (var i = 1; i <= 3; i++) {
          if (i === optionPosition) continue;
          var cur = currentVariant['option' + i];
          var cand = v['option' + i];
          // If both have a value and they differ, this combination is not relevant
          if (cur && cand && cand !== cur) return false;
        }
        return true;
      });

      if (compatible.length === 0) return false;
      return compatible.every(function (v) { return v.hideFromPdp; });
    }

    // Read the display text for an option value radio from its associated label.
    function getOptionText(input, picker) {
      // Dropdown style: input lives inside <label class="popover__value-option">
      var parentLabel = input.closest('label.popover__value-option');
      if (parentLabel) {
        var spans = parentLabel.querySelectorAll('span');
        for (var i = 0; i < spans.length; i++) {
          if (!spans[i].classList.contains('sr-only')) {
            return spans[i].textContent.trim();
          }
        }
        return null;
      }

      // Swatch / block style: sibling <label for="inputId">
      if (input.id) {
        var esc = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(input.id) : input.id;
        var label = picker.querySelector('label[for="' + esc + '"]');
        if (label) {
          var srOnly = label.querySelector('.sr-only');
          return srOnly ? srOnly.textContent.trim() : null;
        }
      }

      return null;
    }

    // Get the element to toggle hidden on for a given input.
    function getHideTarget(input, picker) {
      var parentLabel = input.closest('label.popover__value-option');
      if (parentLabel) return parentLabel;

      var parentDiv = input.closest('div.popover__value-option');
      if (parentDiv) return parentDiv;

      if (input.id) {
        var esc = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(input.id) : input.id;
        return picker.querySelector('label[for="' + esc + '"]');
      }

      return null;
    }

    function updateVisibility(picker, currentVariant) {
      if (!currentVariant) return;

      picker.querySelectorAll('input[type="radio"]').forEach(function (input) {
        var pos = parseInt(input.getAttribute('data-option-position'), 10);
        if (!pos) return;

        var text = getOptionText(input, picker);
        if (!text) return;

        var target = getHideTarget(input, picker);
        if (!target) return;

        // Never hide the currently active value for this option position
        if (currentVariant['option' + pos] === text) {
          target.removeAttribute('hidden');
          input.disabled = false;
          return;
        }

        if (shouldHide(pos, text, currentVariant)) {
          target.setAttribute('hidden', '');
          input.disabled = true;
        } else {
          target.removeAttribute('hidden');
          input.disabled = false;
        }
      });
    }

    // Read the currently selected variant from the server-rendered JSON script tag.
    function getInitialVariant(picker) {
      var script = picker.querySelector('script[data-variant]');
      if (!script) return null;
      try { return JSON.parse(script.textContent); } catch (e) { return null; }
    }

    // Initial run on page load
    document.querySelectorAll('variant-picker').forEach(function (picker) {
      updateVisibility(picker, getInitialVariant(picker));
    });

    // Re-run on every variant change (event fires AFTER product:rerender updates the DOM).
    // event.detail.variant has option1/option2/option3 text values from the theme.
    document.addEventListener('variant:change', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;
      document.querySelectorAll('variant-picker').forEach(function (picker) {
        updateVisibility(picker, variant);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// Price in the add to cart button: trade price and quantity.
// Liquid prints the unit retail price in the button ("data-nk-atc-price", "data-nk-atc-price-cents"). The Function
// Junction Promos app paints the trade pair (trade price + crossed out retail price) into the price block in the
// browser, so we mirror that pair into the button, and multiply whatever is shown by the quantity selector. It re-runs
// whenever the price block, the button or the quantity changes (app repaint, variant change re-render, +/- buttons...).
(function () {
  var AMOUNT_PATTERN = /\d[\d,]*(?:\.\d+)?/;

  function readText(element) {
    var clone = element.cloneNode(true);
    clone.querySelectorAll('.sr-only').forEach(function (node) { node.remove(); });
    return clone.textContent.trim();
  }

  // The shop money format is "${{amount}}": comma thousands separator, dot decimals.
  function parseCents(text) {
    var match = text.match(AMOUNT_PATTERN);
    return match ? Math.round(parseFloat(match[0].replace(/,/g, '')) * 100) : null;
  }

  // Re-uses an already formatted price as the template (currency symbol...), dropping ".00" like the Liquid
  // "money_without_trailing_zeros" filter does.
  function formatCents(cents, template) {
    var amount = (cents / 100).toLocaleString('en-US', {
      minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    });
    return template.replace(AMOUNT_PATTERN, amount);
  }

  function getQuantity(target) {
    var buyButtons = target.closest('buy-buttons');
    var input = buyButtons && buyButtons.querySelector('input[name="quantity"]');
    var quantity = input ? parseInt(input.value, 10) : 1;
    return quantity > 0 ? quantity : 1;
  }

  // A markdown is rendered by Liquid and always carries "price-list--on-sale"; a compare-at price without that class
  // can only have been painted by the app, which is the trade pair.
  function getTradePair(target) {
    var scope = target.closest('.product-info') || document;
    var priceList = scope.querySelector('[data-block-type="price"] price-list');
    if (!priceList || priceList.classList.contains('price-list--on-sale')) return null;

    var salePrice = priceList.querySelector('sale-price');
    var compareAtPrice = priceList.querySelector('compare-at-price');
    if (!salePrice || !compareAtPrice) return null;

    var priceText = readText(salePrice);
    var compareAtPriceText = readText(compareAtPrice);
    var pair = {
      price: parseCents(priceText),
      compareAtPrice: parseCents(compareAtPriceText),
      template: priceText
    };

    return pair.price && pair.compareAtPrice ? pair : null;
  }

  function srOnly(text) {
    var label = document.createElement('span');
    label.className = 'sr-only';
    label.textContent = text;
    return label;
  }

  function render(target) {
    var quantity = getQuantity(target);
    var pair = getTradePair(target);
    var retailTemplate = target.getAttribute('data-nk-atc-price');
    var retailCents = parseInt(target.getAttribute('data-nk-atc-price-cents'), 10);
    var finalText;
    var compareAtText = null;

    if (pair) {
      finalText = formatCents(pair.price * quantity, pair.template);
      compareAtText = formatCents(pair.compareAtPrice * quantity, pair.template);
    } else if (retailCents > 0) {
      finalText = formatCents(retailCents * quantity, retailTemplate);
    } else {
      finalText = retailTemplate;
    }

    // Nothing is written when the output has not changed, so our own writes cannot loop the observer.
    var state = (compareAtText || '') + '|' + finalText;
    if (target.getAttribute('data-nk-atc-state') === state) return;

    var finalPrice = document.createElement('span');
    finalPrice.className = 'nk-atc-price__final';
    finalPrice.textContent = finalText;
    target.textContent = '';

    if (compareAtText) {
      var compareAtPrice = document.createElement('s');
      compareAtPrice.className = 'nk-atc-price__compare';
      compareAtPrice.textContent = compareAtText;
      target.append(
        srOnly(target.getAttribute('data-regular-label')),
        compareAtPrice,
        srOnly(target.getAttribute('data-sale-label')),
        finalPrice
      );
    } else {
      target.append(finalPrice);
    }

    target.setAttribute('data-nk-atc-state', state);
    scheduleWrapCheck(target);
  }

  // Tablet lets a long price wrap under the label ("custom.css"), which would leave the "•" dangling at the end of the
  // first line, so the button gets "nk-atc--wrapped" to stack both lines and hide the separator. The check is re-done
  // without the class, as stacking itself would otherwise keep it wrapped.
  var resizeObserver = window.ResizeObserver ? new ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      scheduleWrapCheck(entry.target.querySelector('[data-nk-atc-price]'));
    });
  }) : null;
  var observedContents = new WeakSet();

  function updateWrap(target) {
    var content = target && target.isConnected && target.closest('.button__content');
    var label = content && content.querySelector('.nk-atc-label');
    if (!label) return;

    content.classList.remove('nk-atc--wrapped');
    var wrapped = target.getBoundingClientRect().top >= label.getBoundingClientRect().bottom - 1;
    content.classList.toggle('nk-atc--wrapped', wrapped);
  }

  // Deferred to the next frame so a class change never resizes the element inside the ResizeObserver callback.
  function scheduleWrapCheck(target) {
    if (target) requestAnimationFrame(function () { updateWrap(target); });
  }

  function observe(target) {
    var content = target.closest('.button__content');
    if (!resizeObserver || !content || observedContents.has(content)) return;
    observedContents.add(content);
    resizeObserver.observe(content);
  }

  function sync() {
    document.querySelectorAll('[data-nk-atc-price]').forEach(function (target) {
      render(target);
      observe(target);
    });
  }

  function onQuantityChange(event) {
    if (event.target.matches && event.target.matches('input[name="quantity"]')) sync();
  }

  function init() {
    sync();
    new MutationObserver(sync).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
    // Typing fires "input", the +/- buttons fire "change"; neither touches the DOM tree.
    document.addEventListener('input', onQuantityChange);
    document.addEventListener('change', onQuantityChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
